/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.UserProgressVisibilityChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerMutation } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './UserProgressVisibilityChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.learning.center.user.progress.rpc.UserProgressVisibilityChirpService#setUserProgressVisibility
 */
export const SET_USER_PROGRESS_VISIBILITY_MUTATION_FIELD_NAME = 'com_hubspot_learning_center_user_progress_rpc_UserProgressVisibilityChirpService_setUserProgressVisibility';
export const SET_USER_PROGRESS_VISIBILITY_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: SET_USER_PROGRESS_VISIBILITY_MUTATION_FIELD_NAME,
  args: ['contentId', 'contentContainerType', 'hidden'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.setUserProgressVisibilityRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});